import { SidebarNav } from 'bento';
import { SidebarNavItemProps } from './SidebarNavItem';
import React, { useState } from 'react';

type SidebarNavCollapseHeaderProps = SidebarNavItemProps<'button'> &
  React.HtmlHTMLAttributes<HTMLButtonElement>;

/**
 * @deprecated Deprecated — no pantry replacement available yet.
 * Migration: No direct pantry mapping — please reach out to the Design Systems team on Slack (e.g., #pantry-design-system) for assistance with a pantry replacement.
 */
export const SidebarNavCollapseHeader = ({
  title,
  icon,
  internal,
  header,
  onClick,
  ...rest
}: SidebarNavCollapseHeaderProps) => {
  const [active, setActive] = useState(false);
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    setActive(!active);
    onClick && onClick(e);
  };
  return (
    <button {...rest} onClick={handleClick}>
      <SidebarNav.Item title={title} icon={icon} internal={internal} header active={active} />
    </button>
  );
};
